module.exports={"wireguard adapter settings":"Paramètres d'adaptateur pour wireguard",option1:"Option 1",option2:"Option 2"};